import { useMemo, useState } from 'react'
import equal from 'fast-deep-equal'
import { useHistory, useLocation } from 'react-router-dom'
import { Chip } from '@winnin/winnin_ui.components.chip'
import { Modal } from '@winnin/winnin_ui.components.modal'

import AudienceFilterDropdownContent from 'components/AudienceFilterDropdownContent'
import getAudienceFromUrl from 'components/TerritoryChipsFilter/utils/getAudienceFromUrl'
import { DEFAULT_AUDIENCE } from 'consts/defaultAudience'
import { SMALL_MODAL } from 'consts/modalStyles'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, buildAudienceObjectTrack, TOLGEE_GLOBALS } from 'utils'

const emptyFunction = () => {}

export default function AudienceFilter() {
  const [isAudienceModalOpen, setIsAudienceModalOpen] = useState(false)

  const t = useTranslate()
  const location = useLocation()
  const history = useHistory()

  const handleAudience = params => {
    const newSearchParams = new URLSearchParams(location.search)
    const audienceKeys = Object.keys(params)
    audienceKeys.forEach(key => {
      const paramValue = params[key]
      if (Array.isArray(paramValue)) {
        newSearchParams.delete(key)
        paramValue.forEach(value => {
          if (value?.value) {
            newSearchParams.append(key, value?.value)
          } else {
            newSearchParams.delete(key)
          }
        })
        return
      }
      if (paramValue?.value) {
        newSearchParams.set(key, paramValue?.value)
      } else {
        newSearchParams.delete(key)
      }
    })

    const { FILTER_AUDIENCE } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(FILTER_AUDIENCE, buildAudienceObjectTrack(params))

    const audienceSearchParams = newSearchParams.toString()
    history.push({ search: audienceSearchParams })
    setIsAudienceModalOpen(false)
  }

  const audience = useMemo(() => {
    return getAudienceFromUrl(location.search)
  }, [location.search])

  const isDefaultAudience = equal(DEFAULT_AUDIENCE, audience)

  return (
    <>
      <Chip
        title={t(TOLGEE_GLOBALS.audience)}
        isActive={!isDefaultAudience}
        handleClick={() => setIsAudienceModalOpen(true)}
        icon="arrowDown"
      />
      {isAudienceModalOpen && (
        <Modal
          isOpen={isAudienceModalOpen}
          style={{
            ...SMALL_MODAL,
            content: {
              ...SMALL_MODAL.content,
              height: '540px',
              width: '466px',
              padding: '0px',
              overflow: 'visible',
            },
          }}
          onRequestClose={() => {
            setIsAudienceModalOpen(false)
          }}
          appElement={document.querySelector('.JobTerritoryComponent-wrapper')}
        >
          <AudienceFilterDropdownContent
            audienceFilters={audience}
            onApply={handleAudience}
            onCancel={() => {
              setIsAudienceModalOpen(false)
            }}
            onTrack={emptyFunction}
            isCountryDisabled={false}
            ignoreStore
            changeAudienceFilter={emptyFunction}
          />
        </Modal>
      )}
    </>
  )
}
